exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding-modal[data-v-1a0b6ed5] {\n  padding: 15px;\n}\n", ""]);

// exports
